import { t } from 'i18next';
import { RedirectPage } from '../../../components/redirect-page';
import { platformLabel, useEnv } from '../../../context/env-context';
import { withPageProviders } from '../../../context/page-context';

export const PriceListsRedirectPage = withPageProviders(PriceListsRedirectContent);

function PriceListsRedirectContent() {
  const platform = platformLabel(useEnv().connected_platform);

  return (
    <RedirectPage
      path="/pricing/lists"
      title={t('price_lists.redirect.title', { platform })}
      subtitle={t('price_lists.redirect.description', { platform })}
      action={t('price_lists.redirect.action')}
      imageType="priceList"
    />
  );
}
